import React, {useState} from "react";
import styled from "styled-components";
import CuadroRequerimientosKpisActualesTab from "./CuadroRequerimientosKpisActualesTab";
import CuadroRequerimientosKpisHistoricosTab from "./CuadroRequerimientosKpisHistoricosTab";

export default function CuadroRequerimientosEstadisticas({ idCuadroSede }) {
 
    const [activeTab, setActiveTab] = useState("kpisActuales");

    const tabs = [
        {
            key: "kpisActuales",
            label: "Ratio Actual",
            component: <CuadroRequerimientosKpisActualesTab idCuadroSede={idCuadroSede} />,
        },
        {
            key: "kpisHistoricos",
            label: "Ratio Histórico",
            component: <CuadroRequerimientosKpisHistoricosTab idCuadroSede={idCuadroSede} />,
        },
    ];

    return (
        <>
            <TabsBar>
                {tabs.map(tab => (
                    <TabButton
                        key={tab.key}
                        $active={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </TabButton>
                ))}
            </TabsBar>

            <TabContent>
                {tabs.find(t => t.key === activeTab)?.component}
            </TabContent>
        </>
    );
}


const TabsBar = styled.div`
    display: flex;
    gap: 4px;
    border-bottom: 1px solid #e5e7eb;
    margin-bottom: 16px;
`;

const TabButton = styled.button`
    padding: 10px 16px;
    background: none;
    border: none;
    border-bottom: 2px solid ${({$active}) => ($active ? "#111827" : "transparent")};
    color: ${({$active}) => ($active ? "#111827" : "#6b7280")};
    font-weight: ${({$active}) => ($active ? "600" : "500")};
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        color: #111827;
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        outline: none;
    }
`;


const TabContent = styled.div`
    padding-top: 8px;
`;
